/** M-WF-01 · Preferenze aziendali di "Compila Orari": apertura, eccedenze, dipendente successivo. */
import React from "react";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { TimesheetPrefillSelect } from "@/foundation/timesheet";
import { SequenceModeSelect } from "@/foundation/sequence";

export const OVERTIME_OPTIONS = [
  { value: "QUALIFY", label: "Nessuna regola: eccedenza da qualificare in anteprima" },
  { value: "STRAORDINARIO", label: "Straordinario (regola aziendale autorizzata)" },
  { value: "BANCA_ORE", label: "Banca ore (regola aziendale autorizzata)" },
];

export function OvertimeAllocationSelect({ value, onChange, disabled }) {
  return (
    <div>
      <Label>Regola aziendale per le ore eccedenti le teoriche</Label>
      <Select value={OVERTIME_OPTIONS.some((o) => o.value === value) ? value : "QUALIFY"} onValueChange={onChange} disabled={disabled}>
        <SelectTrigger data-testid="company-form-overtime-allocation" aria-label="Regola aziendale per le ore eccedenti"><SelectValue /></SelectTrigger>
        <SelectContent>
          {OVERTIME_OPTIONS.map((o) => <SelectItem key={o.value} value={o.value} data-testid={`company-form-overtime-allocation-option-${o.value}`}>{o.label}</SelectItem>)}
        </SelectContent>
      </Select>
      <div className="mt-1 text-[11px] text-suite-neutral-500">Le ore fino alle teoriche sono Ordinario. Impostare Straordinario o Banca ore solo se la regola e la relativa autorizzazione sono previste dall&apos;azienda; altrimenti l&apos;operatore qualifica l&apos;eccedenza giornata per giornata.</div>
    </div>
  );
}

export function TimesheetCompanySettings({ form, setForm, disabled }) {
  const set = (k) => (v) => setForm((f) => ({ ...f, [k]: v }));
  return (
    <>
      <TimesheetPrefillSelect value={form.timesheet_prefill_mode} disabled={disabled} onChange={set("timesheet_prefill_mode")} />
      <OvertimeAllocationSelect value={form.overtime_allocation} disabled={disabled} onChange={set("overtime_allocation")} />
      <SequenceModeSelect value={form.timesheet_next_mode} disabled={disabled} onChange={set("timesheet_next_mode")}
        label='Dopo "Compila Orari" di un dipendente' returnValue="cartellino" returnLabel="Torna sempre al Cartellino"
        data-testid="company-form-timesheet-next-mode" />
    </>
  );
}

export default TimesheetCompanySettings;
